let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("49cor")).then(() => parcelRequire('7Zdh8'));